import * as types from './types';
import { Field } from 'src/config'

export const startQuery = (
    request: types.Request,
    local: boolean
): types.ListQueryAction => {
    return {
        type: types.LIST_START_QUERY,
        request,
        local
    }
}

export const startInitialQuery = (
    resourceName: string,
    local: boolean,
    search?: string,
): types.ListStartInitialQueryAction => {
    return {
        type: types.LIST_START_INITIAL_QUERY,
        resourceName,
        search,
        local
    }
}

export const startExistingQuery = (
    local?: boolean
): types.ListExistingQueryAction => {
    return {
        type: types.LIST_START_EXISTING_QUERY,
        local
    }
}

export const setResponse = (
    response: types.Response
): types.ListResponseAction => {
    return {
        type: types.LIST_RESPONSE,
        response
    }
}

export const setError = (
    error: any
): types.ListErrorAction => {
    return {
        type: types.LIST_ERROR,
        error
    }
}

export const startDelete = (
    resourceName: string,
    id: number
): types.DeleteStartAction => {
    return {
        type: types.ENTITY_START_DELETE,
        resourceName,
        id
    }
}

export const setPageSize = (
    size: number
): types.ListSetPageSizeAction => {
    return {
        type: types.LIST_SET_PAGE_SIZE,
        size
    }
}

export const setPage = (
    page: number
): types.ListSetPageAction => {
    return {
        type: types.LIST_SET_PAGE,
        page
    }
}

export const setSort = (
    attr: string,
    order?: types.SortOrder
): types.ListSortAction => {
    return {
        type: types.LIST_SORT,
        attr,
        order,
    }
}

export const setQuery = (
    query: string,
): types.ListSetQueryAction => {
    return {
        type: types.LIST_SET_QUERY,
        query,
    }
}

export const setAttrs = (
    attrs: _.Dictionary<Field>,
): types.ListSetAttrsAction => {
    return {
        type: types.LIST_SET_ATTRS,
        attrs,
    }
}

export const setFilter = (
    filter: string,
): types.ListSetFilterAction => {
    return {
        type: types.LIST_SET_FILTER,
        filter,
    }
}

export const reset = (): types.ListResetAction => {
    return {
        type: types.LIST_RESET,
    }
}

export const resetConfig = (): types.ListResetConfigAction => {
    return {
        type: types.LIST_RESET_CONFIG,
    }
}

export const setShowHiddenColsAction = (hidden: boolean): types.ListSetShowHiddenAction => {
    return {
        type: types.LIST_SET_HIDDEN,
        hidden,
    }
}

export const listSaveAction = (name: string): types.ListSaveAction => {
    return {
        type: types.LIST_SAVE,
        name,
    }
}

export const listDeleteAction = (id: string): types.ListDeleteAction => {
    return {
        type: types.LIST_DELETE,
        id,
    }
}

export const listStartExportAction = (): types.ListStartExportAction => {
    return {
        type: types.LIST_START_EXPORT,
    }
}
